import React from 'react';
import { format } from 'date-fns';
import { Button } from '../ui/button';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '../ui/dialog';
import { useTrans } from '../../hooks/useTrans';
import { useTemperatureGraphData } from '../../hooks/useTemperatureGraphData';
import { TemperatureChart } from './TemperatureChart';

const NO_DATA_TEXT_BY_STATUS = {
    loading: 'Laden...',
    empty: 'Er is geen data beschikbaar.',
    error: 'Het is niet gelukt om de data op te halen.',
};

function TemperatureGraph({ traceUuid, goodId }) {
    const translate = useTrans();
    const { points, status, lastUpdatedAt } = useTemperatureGraphData(traceUuid, goodId);

    return (
        <div className="flex flex-col gap-[8px]">
            <small className="text-[12px]! text-gray-500">
                {lastUpdatedAt && `${translate('Laatst bijgewerkt')}: ${format(lastUpdatedAt, 'dd-MM-yyyy HH:mm:ss')}`}
            </small>
            <TemperatureChart
                points={points}
                seriesName={translate('Temperatuurverloop')}
                noDataText={status in NO_DATA_TEXT_BY_STATUS ? translate(NO_DATA_TEXT_BY_STATUS[status]) : ''}
            />
        </div>
    );
}

export function TemperatureGraphDialog({ traceUuid, goodId, open, onOpenChange }) {
    const translate = useTrans();

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-h-[90vh] gap-[16px]! overflow-y-auto rounded-[10px]! border! p-[24px]! sm:max-w-[1200px]!">
                <DialogHeader>
                    <DialogTitle className="text-[24px]! font-bold! text-[#003545] sm:text-left!">
                        {translate('Temperatuurverloop')}
                    </DialogTitle>
                    <DialogDescription className="sr-only">
                        {translate('Temperatuurverloop')}
                    </DialogDescription>
                </DialogHeader>
                <TemperatureGraph traceUuid={traceUuid} goodId={goodId} />
                <DialogFooter>
                    <DialogClose asChild>
                        <Button
                            variant="primary"
                            className="rounded-[6px]! border-2! border-solid! bg-[#0e8e6a]! px-[24px]! text-[14px]! font-black! hover:bg-transparent!"
                        >
                            {translate('Sluiten')}
                        </Button>
                    </DialogClose>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
